import type { NotificationShopPreferencesApiClient } from '@fourthwall/services/dist/NotificationShopPreferencesApiClient'

import type { FormValues } from '../Checkout.types'

export type NotificationShopPreferences = Awaited<
  ReturnType<typeof NotificationShopPreferencesApiClient.getNotificationShopPreferences>
>['data']

const getAbandonedCheckoutEmailFrequency = (
  type?: NotificationShopPreferences['mailPreferences']['cartAbandoned']['type'],
): FormValues['abandonedCheckoutEmailFrequency'] => {
  if (type === 'LIGHT') {
    return 'light'
  }

  if (type === 'RECOMMENDED') {
    return 'recommended'
  }

  return 'off'
}

export const getCartAbandonmentInitialValues = (data?: NotificationShopPreferences) => {
  return {
    abandonedCheckoutEmailFrequency: getAbandonedCheckoutEmailFrequency(
      data?.mailPreferences?.cartAbandoned?.type,
    ),
    cartAbandonedIncludePromoCode: data?.mailPreferences?.cartAbandonedIncludePromoCode || false,
  }
}
